import { useQuery } from "react-query";
import { gql } from "graphql-request";
import { IProgram } from "@pbm/programs/contracts/program";
import { usePbm2Url } from "@common/hooks/usePbm2Url";

export function useProgram(programCode: string) {
  const { request } = usePbm2Url();
  return useQuery(`program:${programCode}`, async () => {
    const {
      Rules_programs: { edges },
    } = await request(
      gql`
        query ($programCode: String!) {
          Rules_programs(first: 1, filter: { code: [$programCode] }) {
            edges {
              cursor
              node {
                code
                name
                type
                establishmentIdentity
                defaultTax
                description
                enableAdhesion
                createdAt
                updatedAt
                deletedAt
                effectiveSince
                effectiveUntil
                registrationPeriodStart
                registrationPeriodEnd
                logo
                banner
                comercialCondition
                emailImage
                registrationPolicy {
                  id
                  description
                  requiresRegistration
                  requiresPrescription
                  createdAt
                }
              }
            }
          }
        }
      `,
      { programCode }
    );
    const programs = (edges || []).map(
      ({ node }: { node: IProgram }) => node
    ) as IProgram[];

    return programs.shift();
  });
}
